// extracted by mini-css-extract-plugin
export default {"actionContainer":"STcsmS","popover":"z3Kr6c","label":"YLIMdw"};